export default {
  eRxMFA: ["florida", "iowa", "michigan", "newyork", "delaware", "minnesota", "california"],
  loginMFA: ["newyork"],
};
